import React from 'react';
import { Layout, Menu, Avatar, Dropdown, Typography } from 'antd';
import type { MenuProps } from 'antd';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import {
  ShoppingOutlined,
  AppstoreOutlined,
  UserOutlined,
  LogoutOutlined,
  DashboardOutlined,
  CreditCardOutlined,
  CustomerServiceOutlined,
} from '@ant-design/icons';
import { useAuthStore } from '../../features/auth/store/authStore';
import { WhatsAppFloatingButton } from './WhatsAppFloatingButton';

const { Header, Content } = Layout;
const { Text } = Typography;

export const ClientLayout: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, signOut } = useAuthStore();

  const menuItems: MenuProps['items'] = [
    {
      key: '/client/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
      onClick: () => navigate('/client/dashboard'),
    },
    {
      key: '/client/workflows',
      icon: <AppstoreOutlined />,
      label: 'Meus Workflows',
      onClick: () => navigate('/client/workflows'),
    },
    {
      key: '/client/subscriptions',
      icon: <CreditCardOutlined />,
      label: 'Minhas Assinaturas',
      onClick: () => navigate('/client/subscriptions'),
    },
    {
      key: '/client/marketplace',
      icon: <ShoppingOutlined />,
      label: 'Marketplace',
      onClick: () => navigate('/client/marketplace'),
    },
    {
      key: '/client/payments',
      icon: <CreditCardOutlined />,
      label: 'Pagamentos',
      onClick: () => navigate('/client/payments'),
    },
    {
      key: '/client/support',
      icon: <CustomerServiceOutlined />,
      label: 'Suporte',
      onClick: () => navigate('/client/support'),
    },
  ];

  const userMenuItems: MenuProps['items'] = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'Meu Perfil',
      onClick: () => navigate('/client/profile'),
    },
    {
      type: 'divider',
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Sair',
      danger: true,
      onClick: async () => {
        await signOut();
        navigate('/login');
      },
    },
  ];

  const selectedKey =
    (menuItems.find((item) => location.pathname.startsWith(item?.key as string))?.key as string) ||
    '/client/dashboard';

  return (
    <Layout style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #faf5ff 0%, #fef3f2 100%)' }}>
      <Header style={{ 
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        background: '#7c3aed',
        boxShadow: '0 1px 4px rgba(0,0,0,0.1)',
        padding: '0 24px',
        height: '56px',
        lineHeight: '56px',
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 32, width: '80%' }}>
          <div style={{ 
            fontSize: 20,
            fontWeight: 'bold',
            color: '#fff',
            textShadow: '0 2px 4px rgba(0,0,0,0.1)',
          }}>
            FlowHub
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <Menu
              mode="horizontal"
              selectedKeys={[selectedKey]}
              items={menuItems}
              style={{ 
                border: 'none', 
                width: '100%',
                background: 'transparent',
                lineHeight: '54px',
              }}
              theme="dark"
            />
          </div>
        </div>
        <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
          <div style={{ cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 8, width: '20%', justifyContent: 'flex-end' }}>
            <Avatar icon={<UserOutlined />} style={{ backgroundColor: '#333', color: '#fff' }} />
            <Text style={{ color: '#fff', fontWeight: 400 }}>{user?.profile?.full_name || user?.email}</Text>
          </div>
        </Dropdown>
      </Header>
      <Content style={{ 
        padding: '24px 48px', 
        minHeight: 'calc(100vh - 56px)',
        background: 'transparent',
      }}>
        <Outlet />
      </Content>
      <WhatsAppFloatingButton userName={user?.profile?.full_name || user?.email} />
    </Layout>
  );
};
